export default "/assets/images/live-room-screenshot.webp?e93f20a42a07350b67b599105f7b1500";